angular.module('CarsSaraBo').directive('reviewsFilterDirective', ['$translate', 'DateService','$location','ReviewGAConfig', function ($translate, dateService, $location, reviewGAConfig) {
	return {
		scope: {
			metadata: '=',
			applyFilters: '&',
			reviewsFilter: '=',
			errorFields: '='
		},

		link: function (scope) {
			var gaReview = reviewGAConfig.reviewGa();
            scope.filtersInitialState = {};
			angular.copy(scope.reviewsFilter, scope.filtersInitialState);

			scope.$watch('reviewsFilter.evaluation', function(){
				scope.anyFilterSelected = hasFiltered();
			});

			scope.$watch("errorFields", function () {
				console.log("(reviewsFilterDirective)", scope.errorFields);
            });

			scope.$watch('reviewsFilter.destination.iataCode', function(){
				scope.anyFilterSelected = hasFiltered();
			});

			scope.$watch('reviewsFilter.dateRange.from', function(){
				scope.anyFilterSelected = hasFiltered();
			});

			scope.$watch('reviewsFilter.dateRange.to', function(){
				scope.anyFilterSelected = hasFiltered();
			});

			function hasFiltered(){
				if(!scope.reviewsFilter.destination &&
					(!scope.reviewsFilter.dateRange || Object.getOwnPropertyNames(scope.reviewsFilter.dateRange).length == 0)
					&& !scope.reviewsFilter.evaluation){
					return true;
				}
				return false;
			}

			scope.apply = function(){
				gaReview.send("Filtros_usados", scope.reviewsFilter);
				gaReview.send("Valores_de_filtros", scope.reviewsFilter);
				scope.applyFilters({reviewsFilter: scope.reviewsFilter});
			}

			scope.eraseFilter = function(){
				gaReview.send("Borrar_filtros");
                angular.copy(scope.filtersInitialState, scope.reviewsFilter);
				scope.applyFilters({reviewsFilter: scope.reviewsFilter});
			}
		},

		templateUrl: 'assets/reviews/reviews-filter.html'
	};
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/review_filter_directive.js
// module id = 885
// module chunks = 3